import firebase from 'firebase/app';
import axios from 'axios';

import { reduceTokens } from '../ReduceTokens/ReduceTokens';
import { saveSearch } from '../SaveSearch/SaveSearch';
import { SaveIntVal } from '../SaveIntVal/SaveIntVal';
// import moment from 'moment';


var arr = [];


//filter interest if no interest label arrived yet to see what model we will use with the classifier (either interest or work goal...
//...company info, personal articles, should come in with the interest already labeled and sent to model)
export const getLinkedinV2 = (
    profile, 
    fbProfile, 
    vProp,
    intVal, 
    auth, 
    setContentGen, 
    setGenerating, 
    tokens, 
    docId, 
    url, 
    sendArr, 
    foundInts,
    interestValues,
    setBtnClicked,
    callToAction,
    setEditing 
    ) =>{

    setGenerating(true)
    setEditing(false)
    searchData(intVal, interestValues);
    setBtnClicked(false)

    if(arr.length > 0){
        if(arr[0].classified === 'Hobby'){
            // console.log('hobby withoutAxios')
            personalLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
        } else if(arr[0].classified === 'Work'){
            // console.log('work withoutAxios')
            workLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
        } else{
            // console.log('othered withoutAxios')
            personalLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
        }
    }else{
        // console.log('axios');
        const message= { Input: intVal }
        //first classify interest
        axios
        .post('https://boundapiv2.herokuapp.com/getIntClassified', message)
        .then((response) => {
            // console.log(response.data)
            let classified = response.data
            SaveIntVal(intVal, classified);

            if(classified === 'Hobby'){
                personalLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
            } else if(classified === 'Work'){
                workLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
            } else{
                // console.log('othered')
                personalLI(profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction)
            }
        })
    }
}

const personalLI = (profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction) =>{
    
    let cta = callToAction.length > 0 ? callToAction[0].CTA : 'Would you be open to a 20 min call to explore further?'
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib2R5Ijoic3R1ZmYiLCJpYXQiOjE2MjMxMDUyODR9.8EPq1VG9sw6Dafw9LclznDycHbdJC8wVO3Sqfi_jUMo'

    var splitName = profile?.ProspectName?.split(' ')
    var name = profile.first_name ? profile.first_name : splitName?.[0]
    var input = `${vProp.Pain}\nInterest: ${intVal}\nValue: ${vProp.ValueProp}`
    const message= { Input: input }
    //first classify interest
    axios
    .post('https://boundapiv2.herokuapp.com/LinkedinPersV2', message, { headers: {"Authorization" : `jwt ${token}`} })
    .then((response) => {
        // console.log(response.data)
        let str = response.data
        // console.log(str)
        str = str.substring(str.indexOf(":") + 1)
        // let replaceContent = response.data.replace("Output:", "")
        let replaceContent= str
        let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
        let personalContent = removePer.trim();
        let type = 'Linkedin'

        if(response.data.length > 150){
            reduceTokens(auth, tokens)
            let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
            setContentGen(output)
            generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
        } else {
            let output = `Oops, sorry I went a little blank here. Happens to the best of us :)\n\nDon't worry no token was charged. Just press 'g' or hit the generate button and I'll be good to go again!`
            setContentGen(output)
            generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
        }

    })
}

const workLI = (profile, fbProfile, vProp, intVal, auth, setContentGen, setGenerating, tokens, docId, url, sendArr, foundInts, callToAction) =>{
    
    let cta = callToAction.length > 0 ? callToAction[0].CTA : 'Would you be open to a 20 min call to explore further?'
    const token = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJib2R5Ijoic3R1ZmYiLCJpYXQiOjE2MjMxMDUyODR9.8EPq1VG9sw6Dafw9LclznDycHbdJC8wVO3Sqfi_jUMo'

    var splitName = profile?.ProspectName?.split(' ')
    var name = profile.first_name ? profile.first_name : splitName?.[0]
    var input = `${vProp.Pain}\nInterest: ${intVal}\nValue: ${vProp.ValueProp}`
    const message= { Input: input }
    //first classify interest
    axios
    .post('https://boundapiv2.herokuapp.com/LinkedinWorkV2', message, { headers: {"Authorization" : `jwt ${token}`} })
    .then((response) => {
        // console.log(response.data)
        let str = response.data
        // console.log(str)
        str = str.substring(str.indexOf(":") + 1)
        // let replaceContent = response.data.replace("Output:", "")
        let replaceContent= str
        let removePer = replaceContent.substr(0, replaceContent.lastIndexOf(".") + 1)
        let personalContent = removePer.trim();
        let type = 'Linkedin'

        if(response.data.length > 150){
            reduceTokens(auth, tokens)
            let output = `Hey ${name},\n\n${personalContent}\n\n${cta}`
            setContentGen(output)
            generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
        } else {
            let output = `Oops, sorry I went a little blank here. Happens to the best of us :)\n\nDon't worry no token was charged. Just press 'g' or hit the generate button and I'll be good to go again!`
            setContentGen(output)
            generatedOutreachAdd(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts)
        }

    })
}

//pull that information back into the firebase prospect message generated section
const generatedOutreachAdd = async(docId, fbProfile, output, vProp, intVal, type, setGenerating, auth, profile, url, sendArr, foundInts) =>{
    
    var messagesRef = firebase
    .firestore()
    .collection('organizations')
    .doc(fbProfile.company)
    .collection('prospects')
    .doc(docId)

    messagesRef.update({
        ContentCreated: firebase.firestore.FieldValue.arrayUnion({
            ProspectName: profile?.full_name ? profile?.full_name : profile.ProspectName,
            ProspectContent: output,
            ProspectValuePropUsed: vProp,
            ProspectInterestUsed: intVal,
            ProspectMessageType: type,
            CreatedAt: new Date(),
        })
    }).then(() =>{
        saveSearch(fbProfile, auth, profile, url, sendArr, output, foundInts, docId)
        setGenerating(false)
    })
}

const searchData = (e, projects) => {
    arr = projects.filter(dataContainsTerm(e))
  };

const dataContainsTerm = (term) => {
    return function (element) {
        let word = term?.toString().toLowerCase();
        let data = element;
        if (data.intVal.toString().toLowerCase() === word &&
            startsWith(data.intVal.toString().toLowerCase(), word)) {
                return true;
        }

        return false;
    };
};

function startsWith(str, word) {
    return str.lastIndexOf(word, 0) === 0;
}

